import { ReopenDealNegotiationDocument } from '@/lib/graphql/generated/graphql';
import { isAbortError } from '@/lib/utils/is-abort-error';
import { dealRefetchAtom } from '@/states/deal.state';
import { useMutation } from '@apollo/client/react';
import { useAtomValue } from 'jotai';

export function useReopenNegotiation(dealId: string) {
  const dealRefetch = useAtomValue(dealRefetchAtom);
  const [reopenDealNegotiationMutation, { loading, error }] = useMutation(
    ReopenDealNegotiationDocument
  );

  const reopenNegotiation = async () => {
    const result = await reopenDealNegotiationMutation({
      variables: { dealId },
    });

    const response = result.data?.reopenDealNegotiation;
    if (response?.__typename === 'DomainException') {
      throw new Error(response.code);
    }

    // The mutation already succeeded. A concurrent subscription refresh can
    // supersede this request, so the UI refresh must remain best effort.
    try {
      await dealRefetch.fn();
    } catch (refetchError) {
      if (!isAbortError(refetchError)) {
        console.error(
          'Failed to refetch deal after reopening negotiation:',
          refetchError
        );
      }
    }
    return result;
  };

  return {
    reopenNegotiation,
    loading,
    error,
  };
}
